import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Typography, Card, Statistic, Button, Tooltip, Tag, Space } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, AuditOutlined } from '@ant-design/icons';

import { cardHeaderStyle } from '../util/Style';

const { Title, Text } = Typography;

class PriceSummary extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = props.store;
    }


    approvePrice = async () => {
        await this.store.approve();
        this.props.refreshPriceGrid();
    }

    renderApprovalButton = () => {

        if (this.store.priceUpdateFlag === 2) {
            return (
                <Tag color="geekblue" >The Prices are approved.</Tag>
            )
        }

        if (this.store.canApprove && !this.store.isLoading) {
            return (
                <Tooltip title="The preferred prices of every test will be considered as their respective Approved Price.">
                    <Button onClick={() => this.approvePrice()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} disabled={this.store.isLoading} icon={<AuditOutlined />}>Approve Price</Button>
                </Tooltip>
            )
        }
    }

    render() {

        return (
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Card key="control_summary_lab" headStyle={cardHeaderStyle} style={{ width: "42.5%" }} title={<Title level={5}>Lab Price Range</Title>} >
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text>Current Price</Text>
                            <Space size={"large"}>
                                <Statistic value={this.store.minLabPrice} valueStyle={{ color: 'red' }} prefix={<ArrowDownOutlined />} />
                                <Statistic value={this.store.maxLabPrice} valueStyle={{ color: '#3f8600' }} prefix={<ArrowUpOutlined />} />
                            </Space>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text>Preference</Text>
                            <Space size={"large"}>
                                <Statistic title="" value={this.store.minLabPrefPrice} valueStyle={{ color: 'red' }} prefix={<ArrowDownOutlined />} />
                                <Statistic title="" value={this.store.maxLabPrefPrice} valueStyle={{ color: '#3f8600' }} prefix={<ArrowUpOutlined />} />
                            </Space>
                        </div>
                    </div>
                </Card>

                <Card key="control_summary_self" headStyle={cardHeaderStyle} style={{ width: "42.5%" }} title={<Title level={5}>Walk-in Member Price Range</Title>} >
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text>Current Price</Text>
                            <Space size={"large"}>
                                <Statistic value={this.store.minSelfPrice} valueStyle={{ color: 'red' }} prefix={<ArrowDownOutlined />} />
                                <Statistic value={this.store.maxSelfPrice} valueStyle={{ color: '#3f8600' }} prefix={<ArrowUpOutlined />} />
                            </Space>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text>Preference</Text>
                            <Space size={"large"}>
                                <Statistic value={this.store.minSelfPrefPrice} valueStyle={{ color: 'red' }} prefix={<ArrowDownOutlined />} />
                                <Statistic value={this.store.maxSelfPrefPrice} valueStyle={{ color: '#3f8600' }} prefix={<ArrowUpOutlined />} />
                            </Space>
                        </div>
                    </div>
                </Card>
                <Card style={{ width: "15%", display:"flex",textAlign:"center",alignItems:"center",alignContent:"center" }}>
                    {this.renderApprovalButton()}
                </Card>
            </div>
        )
    }
}

export default observer(PriceSummary);